<ng-container *ngIf="surveyViewerService.activeSurvey$ | async">
  <div data-testId="emailForm">
    <mat-form-field [hideRequiredMarker]="true" data-testId="email" appearance="outline"
                    [ngClass]="isSmallScreen ? 'info-mobile-container' : 'info-desktop-container'">
      <mat-label>{{question.statements[question.emailFormControlName].label | translateLabel: activeLang}}</mat-label>
      <input matInput placeholder="email@example.com"
             [formControl]="$any(questionFormControl)"
             (blur)="questionFormControl.setValue($event.target.value.trim())">
      <mat-error *ngIf="questionFormControl.errors">
        <span *ngIf="questionFormControl.errors.email">{{'Format du courriel invalide.'|transloco}}</span>
        <span *ngIf="questionFormControl.errors.userExist">
          {{'Cette utilisateur a déjà répondu à ce sondage.'|transloco}}</span>
      </mat-error>
    </mat-form-field>
  </div>
  <div *ngIf="question.createUser && (!authService.isLogged() || surveyViewerService.isPreview()) ">
    <mat-checkbox [color]="'primary'" [ngModel]="createUserOnSubmit" (ngModelChange)="surveyViewerService.changeCreateUserOnSubmit($event)">
      {{question.createUser|translateLabel: activeLang}}</mat-checkbox>
  </div>

</ng-container>
